import { Global, ThemeProvider } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Router from '@/router/Router';
import global from '@/styles/global';
import reset from '@/styles/reset';
import theme from '@/styles/theme';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: true, // 모바일 환경 background에서 foreground로 올라올때 필요
			retry: false,
		},
	},
});

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider theme={theme}>
				<div className="wrapper">
					<Global styles={[reset, global]} />
					<Router />
				</div>
			</ThemeProvider>
		</QueryClientProvider>
	);
}

export default App;
